import { render, staticRenderFns } from "./page.vue?vue&type=template&id=d061270a&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=d061270a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d061270a",
  null
  
)

export default component.exports